import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  catchError,
  finalize,
  map,
  merge,
  shareReplay,
  take,
  takeUntil,
  tap,
  throwError,
  timer,
} from 'rxjs';
import { BaseDialog } from '../base-dialog';
import { BASE_DIALOG_IMPORTS } from '../dialog-imports';
import { ConfirmDialogData } from '../dialog.model';

@Component({
  selector: 'app-confirm-dialog',
  imports: [BASE_DIALOG_IMPORTS],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends BaseDialog<ConfirmDialogData> {
  private readonly _dialogRef =
    inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);

  protected readonly loading = signal(false);
  protected readonly submitted = signal(false);

  constructor() {
    super();
  }

  override handleConfirm(): void {
    if (
      this.data.onConfirm &&
      Object.prototype.toString.call(this.data.onConfirm) == '[object Function]'
    ) {
      this.submitted.set(true);

      const delay = this.data.onConfirmLoadingDelay ?? 1000;

      const callback$ = this.data.onConfirm();
      const source$ = callback$.pipe(
        shareReplay(1),
        catchError((error) => {
          this.submitted.set(false);

          return throwError(() => error);
        })
      );

      const loading$ = merge(
        timer(delay).pipe(
          map(() => true),
          takeUntil(source$)
        ),

        source$.pipe(map(() => false))
      );

      loading$
        .pipe(
          takeUntil(source$),
          tap(() => this.loading.set(true)),
          take(1)
        )
        .subscribe();

      source$
        .pipe(
          tap((result) => {
            this.loading.set(false);
            this._dialogRef.close(result);
          }),
          finalize(() => {
            this.loading.set(false);
          }),
          take(1)
        )
        .subscribe();

      // loading$
      //   .pipe(
      //     tap((state) => this.loading.set(state)),
      //     filter((state) => !state),
      //     tap(() => this._dialogRef.close(true)),
      //     finalize(() => {
      //       this.submitted.set(false);
      //       this.loading.set(false);
      //     }),
      //     take(1)
      //   )
      //   .subscribe();

      return;
    }

    this._dialogRef.close(true);
  }
}
